import { AkaStudentDetails } from 'Api/insurance';
import { useFormikContext } from 'formik';
import { useGetDisabledFields } from 'Forms/CancelFormV2/cancelForm.hooks';
import { CancelReason } from 'Forms/CancelFormV2/components/CancelReason';
import { FutureCancelDate } from 'Forms/CancelFormV2/components/FutureCancelDate';
import React from 'react';
import {
  getAkaStudentCancellationOptions,
  showFutureCancelDate,
} from '../cancelAkaStudentForm.helpers';
import { CancelAkaStudentFormValues } from '../cancelAkaStudentForm.types';
import { CancelAkaStudentFormAlerts } from './CancelAkaStudentFormAlerts';

interface CancelAkaStudentFormFieldsProps {
  insurance: AkaStudentDetails;
}

export const CancelAkaStudentFormFields = ({
  insurance,
}: CancelAkaStudentFormFieldsProps): React.ReactElement => {
  const fieldsDisabled = useGetDisabledFields(insurance);
  const { values, isSubmitting } =
    useFormikContext<CancelAkaStudentFormValues>();

  return (
    <>
      <CancelReason
        disabled={fieldsDisabled}
        options={getAkaStudentCancellationOptions()}
      />
      <CancelAkaStudentFormAlerts
        formValues={values}
        isSubmitting={isSubmitting}
      />
      {showFutureCancelDate(values) && (
        <FutureCancelDate disabled={fieldsDisabled} />
      )}
    </>
  );
};
